// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "MoneyflowTrackerChart__textCenter__Hfeg6";
export const moneyflowTrackerChart = "MoneyflowTrackerChart__moneyflowTrackerChart__x9vU1";
export const current = "MoneyflowTrackerChart__current__TfJon";
export const tooltipContainer = "MoneyflowTrackerChart__tooltipContainer__tCLH3";
export const projection = "MoneyflowTrackerChart__projection__a9COq";
export const limit = "MoneyflowTrackerChart__limit__I2WFV";
export const moneyflowBar = "MoneyflowTrackerChart__moneyflowBar__SszYc";
export const value = "MoneyflowTrackerChart__value__kAf19";
export const negativeValue = "MoneyflowTrackerChart__negativeValue__i1ohn";
export const outerLabel = "MoneyflowTrackerChart__outerLabel__DLRSg";
export const warning = "MoneyflowTrackerChart__warning__nQOXe";
export const over = "MoneyflowTrackerChart__over__a75wz";
export const limitDot = "MoneyflowTrackerChart__limitDot__cYr8a";